import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Solution() {
  const features = ['Ver próximas reuniones.', 'Revisar agendas y minutas.', 'Reportar problemas locales.', 'Contactar al comité.', 'Suscribirte a noticias y alertas.', 'Participar como voluntario.', 'Encontrar recursos comunitarios.', 'Conocer proyectos, eventos e historias del vecindario.'];
  return <section className="py-24 px-6 lg:px-8 bg-charcoal text-white" data-id="element-432">
      <div className="max-w-4xl mx-auto text-center" data-id="element-433">
        <h2 className="text-4xl md:text-5xl font-bold mb-8 text-softblue" data-id="element-434">
          La Solución
        </h2>
        <p className="text-xl md:text-2xl mb-12 text-softblue-dark leading-relaxed" data-id="element-435">
          Esta nueva página comunitaria funciona como un centro claro de
          información, participación y acción.
        </p>

        <div className="bg-charcoal-light/30 rounded-2xl p-8 md:p-12 border border-charcoal-light/50 backdrop-blur-sm" data-id="element-436">
          <h3 className="text-2xl font-semibold mb-8 text-sky" data-id="element-437">
            Un solo lugar para:
          </h3>

          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-4 text-left mb-12" data-id="element-438">
            {features.map((feature, index) => <div key={index} className="flex items-center gap-3" data-id="element-439">
                <CheckCircle2 className="w-6 h-6 text-sky shrink-0" data-id="element-440" />
                <span className="text-lg" data-id="element-441">{feature}</span>
              </div>)}
          </div>

          <div className="bg-warm text-charcoal p-6 rounded-xl font-bold text-xl md:text-2xl shadow-xl" data-id="element-442">
            La meta es simple: Ayudar a que más vecinos pasen de estar
            informados a estar involucrados.
          </div>
        </div>
      </div>
    </section>;
}